<div class="status-container"
  [class.show-status-label]="showStatusLabel"
  [class.unread]="unread"
  [class.print-view]="printView"
  [class.dense]="dense"
  [class.compact-view]="compactView"
  [class.completed]="isDone">

  @if (statusText || remainingTime) {
    <div class="status-content">
      @if (showStatusLabel) {
        <span class="status-label">
          <span>
            <span class="label" fiTranslation="REQUEST_DETAIL_HEADLINE_STATUS"></span>:
          </span>
          <span class="text">{{ statusText }}</span>
        </span>
      }
      <span class="status-label in-line">
        @if (!isDone) {
          <span class="status-indicator-color" [class.print-view]="printView" [class.dense]="dense"
            [class.compact-view]="compactView" [class.move-to-end]="moveIndicatorToEnd"
            [ngClass]="colorClassName">
          </span>
        }
        <span class="status-data" [class.print-view]="printView" [class.overview-status]="isOverview"
          [class.mobile-is-done-show]="isDone">
          @if (isDone) {
            <span class="body-data-text backspace label" [class.unread]="!printView && unread"
            fiTranslation="REQUEST_OVERVIEW_DONE_LEAD_STATUS"></span>
          }
          @if (remainingTime) {
            <span class="body-data-text text"
            [class.unread]="!printView && unread" fiTranslation="{{remainingTime}}"></span>
          }
        </span>
      </span>
    </div>
  }

</div>
